import { FIN_CAS_MOVEMENTS_ITEM } from './fin-cas-movements.js'
import { FIN_CAS_CASHES_ITEM } from './fin-cas-cashes.js'

/** @type {import('../help-index.js').HelpScreen} */
export const FIN_CAS_HELP = {
  screenId: 'fin-cas',
  label: 'Caja',
  navPath: 'Finanzas → Caja',
  keywords: [
    'caja', 'efectivo', 'movimiento de caja', 'saldo', 'arqueo', 'cierre de caja',
    'apertura de caja', 'traspaso', 'cobro efectivo', 'pago efectivo',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'En Caja controlás el efectivo: movimientos, saldo, apertura y cierre con arqueo, traspasos y cobros o pagos en efectivo. Desde «Cajas» definís las imputaciones cuando hay diferencias al contar. Tocá cada tema abajo para ver los pasos.',
  sidebarItems: [FIN_CAS_MOVEMENTS_ITEM, FIN_CAS_CASHES_ITEM],
}
